import { NumberInput as MantineNumberInput, NumberInputProps as MantineNumberInputProps } from '@mantine/core';
import { useMemo, useState } from 'react';

interface NumberInputProps extends MantineNumberInputProps {
  'data-pw'?: string;
}

export const NumberInput: React.FC<NumberInputProps> = (props) => {
  const [focused, setFocused] = useState(false);

  const floating = useMemo(() => {
    if (typeof props.value === 'string') {
      return props.value.trim().length !== 0 || focused ? true : undefined;
    }

    if (typeof props.value === 'number') {
      return !Number.isNaN(props.value) ? true : undefined;
    }

    return focused || undefined;
  }, [props.value, focused]);

  const handleFocus = (evt) => {
    setFocused(true);
    props.onFocus?.(evt);
  };

  const handleBlur = (evt) => {
    setFocused(false);
    props.onBlur?.(evt);
  };

  return (
    <MantineNumberInput
      {...props}
      onFocus={handleFocus}
      onBlur={handleBlur}
      autoComplete={props.autoComplete ?? 'on'}
      data-floating={floating}
      labelProps={{ ...props.labelProps, 'data-floating': floating, 'data-error': props.error }}
      data-pw={props['data-pw']}
    />
  );
};
